module.exports = __webpack_public_path__ + "img/partner1.4b0225d2.png";